/* ============================================================
   DORē PARIS — Theme JS
   ============================================================ */

/* ── ÉCHAPPEMENT HTML (sécurité : neutralise tout contenu injecté dynamiquement) ── */
function doreEscapeHTML(str) {
  const div = document.createElement('div');
  div.textContent = str == null ? '' : String(str);
  return div.innerHTML;
}

/* ── FOCUS TRAP (accessibilité clavier des panneaux) ── */
function doreFocusableElements(container) {
  return Array.prototype.slice.call(
    container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
  ).filter(function(el) { return el.offsetParent !== null; });
}

function doreTrapFocus(container) {
  function handleKeydown(e) {
    if (e.key !== 'Tab') return;
    const focusable = doreFocusableElements(container);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
  container.addEventListener('keydown', handleKeydown);
  return function releaseFocusTrap() {
    container.removeEventListener('keydown', handleKeydown);
  };
}

(function() {
  'use strict';

  /* ── CUSTOM CURSOR (souris uniquement — évite une boucle requestAnimationFrame inutile sur mobile/tactile) ── */
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursorRing');
  const isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (cursor && ring && isFinePointer) {
    let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.style.left = mouseX + 'px';
      cursor.style.top = mouseY + 'px';
    });

    function animateRing() {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      ring.style.left = ringX + 'px';
      ring.style.top = ringY + 'px';
      requestAnimationFrame(animateRing);
    }
    animateRing();

    const hoverEls = 'a, button, .cat-card, .product-card, .strip-item, .service-item, .composition-product, .compositions__arrow, .instagram-post, select, input, [role="button"]';
    document.querySelectorAll(hoverEls).forEach(el => {
      el.addEventListener('mouseenter', () => { cursor.classList.add('hover'); ring.classList.add('hover'); });
      el.addEventListener('mouseleave', () => { cursor.classList.remove('hover'); ring.classList.remove('hover'); });
    });
  }

  /* ── NAVBAR SCROLL ── */
  const navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', () => {
      navbar.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ── MOBILE NAV ── */
const hamburger = document.getElementById('navHamburger');
const mobileNav = document.getElementById('navMobile');
const mobileClose = document.getElementById('navMobileClose');

let mobileNavReleaseFocusTrap = null;
let mobileNavLastFocusedEl = null;

function openMobileNav() {
  mobileNavLastFocusedEl = document.activeElement;
  mobileNav.classList.add('open');
  hamburger.setAttribute('aria-expanded', 'true');
  mobileNav.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  mobileNavReleaseFocusTrap = doreTrapFocus(mobileNav);
  if (mobileClose) mobileClose.focus();
}

function closeMobileNav() {
  mobileNav.classList.remove('open');
  hamburger.setAttribute('aria-expanded', 'false');
  mobileNav.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  if (mobileNavReleaseFocusTrap) { mobileNavReleaseFocusTrap(); mobileNavReleaseFocusTrap = null; }
  if (mobileNavLastFocusedEl && typeof mobileNavLastFocusedEl.focus === 'function') {
    mobileNavLastFocusedEl.focus();
    mobileNavLastFocusedEl = null;
  }
}

if (hamburger && mobileNav) {
  hamburger.addEventListener('click', () => {
    if (mobileNav.classList.contains('open')) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  });

  if (mobileClose) {
    mobileClose.addEventListener('click', closeMobileNav);
    mobileClose.addEventListener('touchend', function(e) {
      e.preventDefault();
      closeMobileNav();
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileNav.classList.contains('open')) closeMobileNav();
  });

  // Sous-menus dépliables
  mobileNav.querySelectorAll('.nav-mobile__toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      const submenu = document.getElementById(this.getAttribute('aria-controls'));
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      if (submenu) submenu.classList.toggle('open', !expanded);
    });
  });

  mobileNav.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMobileNav);
  });

  // Onglets Catalogue / La Maison
  const mobileTabs = mobileNav.querySelectorAll('.nav-mobile__tab');
  const mobilePanels = mobileNav.querySelectorAll('.nav-mobile__panel');
  mobileTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const target = this.dataset.mobileTab;
      mobileTabs.forEach(function(t) {
        t.classList.toggle('active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      mobilePanels.forEach(function(panel) {
        panel.hidden = panel.dataset.mobilePanel !== target;
      });
      mobileNav.querySelector('.nav-mobile__scroll').scrollTop = 0;
    });
  });
}

  /* ── SCROLL REVEAL ── */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('visible');
          }, i * 80);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach(el => observer.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('visible'));
  }

  /* ── ANNOUNCEMENT BAR CLOSE (optional) ── */
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    const dismissed = sessionStorage.getItem('announcement-dismissed');
    if (dismissed) announcementBar.style.display = 'none';
  }

  /* ── CART DRAWER / MINI-CART (AJAX) ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badges = document.querySelectorAll('.cart-badge');
        badges.forEach(badge => {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(() => {});
  }

  /* ── WISHLIST (localStorage) ── */
function updateWishlistBadge() {
  const badges = [document.getElementById('WishlistBadge'), document.getElementById('WishlistBadgeMobile')];
  const wl = JSON.parse(localStorage.getItem('dore-wishlist') || '[]');
  badges.forEach(function(badge) {
    if (!badge) return;
    badge.textContent = wl.length;
    badge.style.display = wl.length ? 'flex' : 'none';
  });
}

function initWishlist() {
  updateWishlistBadge();

  const wishlistBtns = document.querySelectorAll('.wishlist-btn');
  wishlistBtns.forEach(btn => {
    const productId     = btn.dataset.productId;
    const productHandle = btn.dataset.productHandle;
    const wishlist = JSON.parse(localStorage.getItem('dore-wishlist') || '[]');

    if (productId && wishlist.find(item => item.id == productId)) {
      btn.textContent = '♥';
      btn.style.color = 'var(--or-rose)';
    }

    btn.addEventListener('click', function() {
      if (!productId) return;
      let wl  = JSON.parse(localStorage.getItem('dore-wishlist') || '[]');
      const idx = wl.findIndex(item => item.id == productId);
      if (idx === -1) {
        wl.push({ id: productId, handle: productHandle });
        this.textContent = '♥';
        this.style.color = 'var(--or-rose)';
      } else {
        wl.splice(idx, 1);
        this.textContent = '♡';
        this.style.color = '';
      }
      localStorage.setItem('dore-wishlist', JSON.stringify(wl));
      updateWishlistBadge();
    });
  });
}
initWishlist();


  /* ── PRODUCT FORM — Add to cart feedback ── */
  const productForms = document.querySelectorAll('.product-form-submit');
  productForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const btn = this.querySelector('[name="add"]');
      if (btn && !btn.disabled) {
        const orig = btn.textContent;
        btn.textContent = 'Ajout en cours...';
        setTimeout(() => {
          btn.textContent = orig;
          updateCartCount();
        }, 1500);
      }
    });
  });


  /* ── COLLECTION SORT ── */
  const sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── NEWSLETTER FORM FEEDBACK ── */
  const newsletterForm = document.getElementById('newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function() {
      const btn = this.querySelector('.newsletter-btn');
      if (btn) {
        btn.textContent = '...';
        setTimeout(() => { btn.textContent = 'S\'inscrire'; }, 3000);
      }
    });
  }

  /* ── LAZY LOADING IMAGES POLYFILL ── */
  if ('loading' in HTMLImageElement.prototype === false) {
    const images = document.querySelectorAll('img[loading="lazy"]');
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) img.src = img.dataset.src;
          imageObserver.unobserve(img);
        }
      });
    });
    images.forEach(img => imageObserver.observe(img));
  }

  /* ── SMOOTH ANCHOR SCROLL ── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── CURSOR REFRESH ON DYNAMIC CONTENT ── */
  if (cursor && ring) {
    document.addEventListener('shopify:section:load', () => {
      const hoverEls = 'a, button, .cat-card, .product-card, .strip-item, .service-item';
      document.querySelectorAll(hoverEls).forEach(el => {
        el.addEventListener('mouseenter', () => { cursor.classList.add('hover'); ring.classList.add('hover'); });
        el.addEventListener('mouseleave', () => { cursor.classList.remove('hover'); ring.classList.remove('hover'); });
      });
    });
  }

})();

/* ── SEARCH OVERLAY ── */
(function() {
  const overlay   = document.getElementById('SearchOverlay');
  const toggleBtn = document.getElementById('SearchToggle');
  const closeBtn  = document.getElementById('SearchClose');
  const backdrop  = document.getElementById('SearchBackdrop');
  const input     = document.getElementById('SearchInput');
  const results   = document.getElementById('SearchResults');
  if (!overlay || !toggleBtn) return;

  let debounceTimer;
  let releaseFocusTrap = null;
  let lastFocusedEl = null;

  function openSearch() {
    lastFocusedEl = document.activeElement;
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    releaseFocusTrap = doreTrapFocus(overlay);
    setTimeout(() => input && input.focus(), 300);
  }

  function closeSearch() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (results) results.innerHTML = '';
    if (input) input.value = '';
    if (releaseFocusTrap) { releaseFocusTrap(); releaseFocusTrap = null; }
    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') { lastFocusedEl.focus(); lastFocusedEl = null; }
  }

  toggleBtn.addEventListener('click', openSearch);

  const mobileToggleBtn = document.getElementById('MobileSearchToggle');
  if (mobileToggleBtn) {
    mobileToggleBtn.addEventListener('click', function() {
      const mobileNav = document.getElementById('navMobile');
      const hamburger = document.getElementById('navHamburger');
      if (mobileNav && mobileNav.classList.contains('open')) {
        mobileNav.classList.remove('open');
        mobileNav.setAttribute('aria-hidden', 'true');
        if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
      openSearch();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('open')) closeSearch();
    if ((e.key === 'k' && (e.metaKey || e.ctrlKey))) { e.preventDefault(); openSearch(); }
  });

  /* Live search via Shopify Predictive Search API */
  if (input && results) {
    input.addEventListener('input', function() {
      const q = this.value.trim();
      clearTimeout(debounceTimer);

      if (q.length < 2) { results.innerHTML = ''; return; }

      results.innerHTML = '<div class="search-loading"><div class="search-loading__dots"><span></span><span></span><span></span></div></div>';

      debounceTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title`)
          .then(r => r.json())
          .then(data => {
            const products = data.resources?.results?.products || [];
            if (products.length === 0) {
              results.innerHTML = '<p class="search-no-result">Aucun résultat pour "' + doreEscapeHTML(q) + '"</p>';
              return;
            }
            const grid = document.createElement('div');
            grid.className = 'search-results-grid';
            products.forEach(p => {
              const item = document.createElement('a');
              item.className = 'search-result-item';
              item.href = p.url;
              const safeTitle = doreEscapeHTML(p.title);
              const img = p.featured_image?.url
                ? `<img src="${p.featured_image.url}&width=300" alt="${safeTitle}" loading="lazy">`
                : `<div style="aspect-ratio:1;background:#111;display:flex;align-items:center;justify-content:center;font-size:2rem;opacity:0.1;">✦</div>`;
              const price = p.price ? (parseInt(p.price)).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }) : '';
              item.innerHTML = `${img}<div class="search-result-item__info"><p class="search-result-item__name">${safeTitle}</p><p class="search-result-item__price">${price}</p></div>`;
              grid.appendChild(item);
            });
            results.innerHTML = '';
            results.appendChild(grid);
          })
          .catch(() => { results.innerHTML = ''; });
      }, 300);
    });
  }
})();
/* ── CART QUANTITY BUTTONS ── */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.qty-btn');
  if (!btn) return;

  const line = btn.dataset.line;
  const input = btn.closest('.quantity-selector')?.querySelector('input');
  if (!input || !line) return;

  let qty = parseInt(input.value) || 1;
  if (btn.classList.contains('qty-btn--plus')) qty++;
  if (btn.classList.contains('qty-btn--minus')) qty = Math.max(0, qty - 1);

  input.value = qty;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: parseInt(line), quantity: qty })
  })
  .then(r => r.json())
  .then(() => location.reload())
  .catch(e => console.error(e));
});

/* ── COMPOSITIONS CAROUSEL ── */
(function() {
  const track = document.getElementById('CompositionsTrack');
  if (!track) return;

  const slides   = track.querySelectorAll('.composition-slide');
  const prevBtn  = document.getElementById('CompPrev');
  const nextBtn  = document.getElementById('CompNext');
  const counter  = document.getElementById('CompCurrent');
  if (!slides.length) return;

  function activeIndex() {
    const trackLeft = track.getBoundingClientRect().left;
    let closest = 0;
    let closestDist = Infinity;
    slides.forEach((slide, i) => {
      const dist = Math.abs(slide.getBoundingClientRect().left - trackLeft);
      if (dist < closestDist) { closestDist = dist; closest = i; }
    });
    return closest;
  }

  function refreshUI() {
    const i = activeIndex();
    if (counter) counter.textContent = i + 1;
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  let scrollAnimFrame;
  function smoothScrollTo(targetLeft, duration) {
    if (scrollAnimFrame) cancelAnimationFrame(scrollAnimFrame);
    const startLeft = track.scrollLeft;
    const distance = targetLeft - startLeft;
    const startTime = performance.now();

    function step(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      track.scrollLeft = startLeft + distance * easeInOutCubic(progress);
      if (progress < 1) {
        scrollAnimFrame = requestAnimationFrame(step);
      } else {
        scrollAnimFrame = null;
      }
    }
    scrollAnimFrame = requestAnimationFrame(step);
  }

  function goTo(index) {
    // boucle : après la dernière diapo, repart au début (et inversement)
    const clamped = (index + slides.length) % slides.length;
    const target = slides[clamped];
    const targetLeft = target.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    smoothScrollTo(targetLeft, 900);
  }

  const speed = (parseInt(track.dataset.autoplaySpeed, 10) || 5) * 1000;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let autoplayTimer = null;

  function startAutoplay() {
    if (reduceMotion || slides.length < 2) return;
    stopAutoplay();
    autoplayTimer = setInterval(() => goTo(activeIndex() + 1), speed);
  }
  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
    autoplayTimer = null;
  }

  if (prevBtn) prevBtn.addEventListener('click', () => { goTo(activeIndex() - 1); startAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { goTo(activeIndex() + 1); startAutoplay(); });

  track.addEventListener('mouseenter', stopAutoplay);
  track.addEventListener('mouseleave', startAutoplay);

  let scrollTimer;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(refreshUI, 100);
  }, { passive: true });

  refreshUI();
  startAutoplay();
})();

/* ── CART DRAWER ── */
(function() {
  const drawer   = document.getElementById('CartDrawer');
  if (!drawer) return;

  const backdrop    = document.getElementById('CartDrawerBackdrop');
  const closeBtn    = document.getElementById('CartDrawerClose');
  const continueBtn = document.getElementById('CartDrawerContinue');
  const body        = document.getElementById('CartDrawerBody');
  const footer      = document.getElementById('CartDrawerFooter');
  const countEl     = document.getElementById('CartDrawerCount');
  const subtotalEl  = document.getElementById('CartDrawerSubtotal');
  const toggle      = document.getElementById('CartToggle');

  const shippingEl     = document.getElementById('CartDrawerShipping');
  const shippingTextEl = document.getElementById('CartDrawerShippingText');
  const shippingFillEl = document.getElementById('CartDrawerShippingFill');
  const upsellEl       = document.getElementById('CartDrawerUpsell');
  const upsellListEl   = document.getElementById('CartDrawerUpsellList');
  const freeShippingThreshold = drawer.dataset.freeShippingThreshold
    ? parseInt(drawer.dataset.freeShippingThreshold, 10)
    : null;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function cdnResize(url, width) {
    if (!url) return '';
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function itemHTML(item) {
    const img = item.image ? cdnResize(item.image, 160) : '';
    const variantHTML = (item.variant_title && item.variant_title !== 'Default Title')
      ? `<p class="cart-drawer-item__variant">${doreEscapeHTML(item.variant_title)}</p>`
      : '';
    return `
      <div class="cart-drawer-item" data-key="${item.key}">
        <a href="${item.url}" class="cart-drawer-item__img">
          ${img ? `<img src="${img}" alt="" loading="lazy" width="80" height="104">` : ''}
        </a>
        <div class="cart-drawer-item__details">
          <h4 class="cart-drawer-item__name"><a href="${item.url}">${doreEscapeHTML(item.product_title)}</a></h4>
          ${variantHTML}
          <div class="cart-drawer-item__footer">
            <div class="quantity-selector quantity-selector--sm">
              <button type="button" class="qty-btn qty-btn--minus" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Diminuer la quantité">−</button>
              <span class="qty-value">${item.quantity}</span>
              <button type="button" class="qty-btn qty-btn--plus" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Augmenter la quantité">+</button>
            </div>
            <span class="cart-drawer-item__price">${formatMoney(item.final_line_price)}</span>
          </div>
        </div>
        <button type="button" class="cart-drawer-item__remove" data-key="${item.key}" aria-label="Supprimer l'article">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
    `;
  }

  function updateShippingBar(cart) {
    if (!shippingEl || !freeShippingThreshold) return;
    if (cart.item_count === 0) {
      shippingEl.style.display = 'none';
      return;
    }
    shippingEl.style.display = '';
    const remaining = freeShippingThreshold - cart.total_price;
    const pct = Math.min(100, (cart.total_price / freeShippingThreshold) * 100);
    if (shippingFillEl) shippingFillEl.style.width = pct + '%';
    if (shippingTextEl) {
      shippingTextEl.textContent = remaining <= 0
        ? '🎉 Livraison offerte débloquée !'
        : 'Plus que ' + formatMoney(remaining) + ' pour la livraison offerte';
    }
  }

  function upsellItemHTML(product) {
    const variant = product.variants[0];
    const safeTitle = doreEscapeHTML(product.title);
    const img = product.featured_image ? cdnResize(product.featured_image, 240) : (product.images && product.images[0] ? cdnResize(product.images[0], 240) : '');
    const imgHTML = img ? '<img src="' + img + '" alt="" loading="lazy" width="100" height="133">' : '';

    let addHTML;
    if (!product.available) {
      addHTML = '<span class="cart-upsell-item__add cart-upsell-item__add--disabled">Épuisé</span>';
    } else if (product.variants.length === 1) {
      addHTML = '<form class="quick-add-form cart-upsell-item__form">' +
        '<input type="hidden" name="id" value="' + variant.id + '">' +
        '<button type="submit" name="add" class="cart-upsell-item__add">Ajouter au panier</button>' +
        '</form>';
    } else {
      addHTML = '<a href="' + product.url + '" class="cart-upsell-item__add">Choisir</a>';
    }

    return '<div class="cart-upsell-item">' +
      '<a href="' + product.url + '" class="cart-upsell-item__img">' + imgHTML + '</a>' +
      '<div class="cart-upsell-item__info">' +
        '<a href="' + product.url + '" class="cart-upsell-item__name">' + safeTitle + '</a>' +
        '<p class="cart-upsell-item__price">' + (parseFloat(variant.price) / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }) + '</p>' +
        addHTML +
      '</div>' +
    '</div>';
  }

  function updateUpsell(cart) {
    if (!upsellEl || !upsellListEl) return;
    if (cart.item_count === 0) {
      upsellEl.style.display = 'none';
      upsellListEl.innerHTML = '';
      return;
    }

    const lastItem = cart.items[cart.items.length - 1];
    const cartProductIds = cart.items.map(function(i) { return i.product_id; });

    fetch('/recommendations/products.json?product_id=' + lastItem.product_id + '&limit=6&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        const products = (data.products || [])
          .filter(function(p) { return cartProductIds.indexOf(p.id) === -1; })
          .slice(0, 3);

        if (!products.length) {
          upsellEl.style.display = 'none';
          upsellListEl.innerHTML = '';
          return;
        }

        upsellListEl.innerHTML = products.map(upsellItemHTML).join('');
        upsellEl.style.display = '';
      })
      .catch(function() {
        upsellEl.style.display = 'none';
      });
  }

  function renderCart(cart) {
    document.querySelectorAll('.cart-badge').forEach(function(badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    updateShippingBar(cart);
    updateUpsell(cart);
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty">' +
        '<p>Votre panier est vide.</p>' +
        '<a href="/collections/all" class="btn-secondary">Découvrir la collection</a>' +
        '</div>';
      if (footer) footer.style.display = 'none';
      return;
    }

    body.innerHTML = cart.items.map(itemHTML).join('');
    if (footer) footer.style.display = '';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function(r) { return r.json(); })
      .then(renderCart)
      .catch(function() {});
  }

  let releaseFocusTrap = null;
  let lastFocusedEl = null;

  function openDrawer() {
    lastFocusedEl = document.activeElement;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    releaseFocusTrap = doreTrapFocus(drawer);
    const focusable = doreFocusableElements(drawer);
    if (focusable.length) focusable[0].focus();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (releaseFocusTrap) { releaseFocusTrap(); releaseFocusTrap = null; }
    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') { lastFocusedEl.focus(); lastFocusedEl = null; }
  }

  if (toggle) {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      fetchCart().then(renderCart);
      openDrawer();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
  });

  if (body) {
    body.addEventListener('click', function(e) {
      const minus = e.target.closest('.qty-btn--minus');
      const plus = e.target.closest('.qty-btn--plus');
      const remove = e.target.closest('.cart-drawer-item__remove');
      if (minus) changeLine(minus.dataset.key, parseInt(minus.dataset.qty, 10));
      else if (plus) changeLine(plus.dataset.key, parseInt(plus.dataset.qty, 10));
      else if (remove) changeLine(remove.dataset.key, 0);
    });
  }

  document.addEventListener('cart:refresh', function(e) {
    fetchCart().then(function(cart) {
      renderCart(cart);
      if (e.detail && e.detail.open) openDrawer();
    });
  });
})();

/* ── FILTER DRAWER (page collection) ── */
(function() {
  const drawer = document.getElementById('FilterDrawer');
  if (!drawer) return;

  const toggle   = document.getElementById('FilterToggle');
  const closeBtn = document.getElementById('FilterDrawerClose');
  const backdrop = document.getElementById('FilterDrawerBackdrop');

  let releaseFocusTrap = null;
  let lastFocusedEl = null;

  function openDrawer() {
    lastFocusedEl = document.activeElement;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    releaseFocusTrap = doreTrapFocus(drawer);
    const focusable = doreFocusableElements(drawer);
    if (focusable.length) focusable[0].focus();
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (releaseFocusTrap) { releaseFocusTrap(); releaseFocusTrap = null; }
    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') { lastFocusedEl.focus(); lastFocusedEl = null; }
  }

  if (toggle) toggle.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
  });
})();

/* ── QUICK ADD (cartes produit) ── */
document.addEventListener('submit', function(e) {
  const form = e.target.closest('.quick-add-form');
  if (!form) return;
  e.preventDefault();

  const btn = form.querySelector('[name="add"]');
  const originalText = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = '...'; }

  fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) throw new Error(data.description || 'Erreur');
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    })
    .catch(function() {})
    .finally(function() {
      if (btn) { btn.disabled = false; btn.textContent = originalText; }
    });
});

/* ── NEWSLETTER POPUP ── */
(function() {
  const popup = document.getElementById('NewsletterPopup');
  if (!popup) return;

  const backdrop   = document.getElementById('NewsletterPopupBackdrop');
  const closeBtn   = document.getElementById('NewsletterPopupClose');
  const dismissBtn = document.getElementById('NewsletterPopupDismiss');
  const form       = document.getElementById('newsletter-popup-form');
  const STORAGE_KEY = 'dore-popup-snoozed-until';
  const delay = (parseInt(popup.dataset.delay, 10) || 6) * 1000;

  let releaseFocusTrap = null;
  let lastFocusedEl = null;

  function isSnoozed() {
    const until = localStorage.getItem(STORAGE_KEY);
    return !!until && Date.now() < parseInt(until, 10);
  }

  function openPopup(force) {
    if (!force && isSnoozed()) return;
    lastFocusedEl = document.activeElement;
    popup.classList.add('open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    releaseFocusTrap = doreTrapFocus(popup);
    const focusable = doreFocusableElements(popup);
    if (focusable.length) focusable[0].focus();
  }

  function closePopup(snoozeDays) {
    popup.classList.remove('open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (snoozeDays) {
      localStorage.setItem(STORAGE_KEY, (Date.now() + snoozeDays * 86400000).toString());
    }
    if (releaseFocusTrap) { releaseFocusTrap(); releaseFocusTrap = null; }
    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') { lastFocusedEl.focus(); lastFocusedEl = null; }
  }

  // Retour après envoi du formulaire : on rouvre la popup pour afficher le résultat
  // (le code promo n'existe dans la page qu'après une inscription réussie).
  const postedSuccess = document.getElementById('NewsletterPopupSuccess');
  const postedError = document.getElementById('NewsletterPopupError');
  if (postedError) localStorage.removeItem(STORAGE_KEY);
  if (postedSuccess || postedError) {
    openPopup(true);
  } else if (!isSnoozed()) {
    setTimeout(openPopup, delay);
  }

  if (closeBtn) closeBtn.addEventListener('click', () => closePopup(7));
  if (dismissBtn) dismissBtn.addEventListener('click', () => closePopup(7));
  if (backdrop) backdrop.addEventListener('click', () => closePopup(7));

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('open')) closePopup(7);
  });

  if (form) {
    form.addEventListener('submit', function() {
      localStorage.setItem(STORAGE_KEY, (Date.now() + 365 * 86400000).toString());
    });
  }
})();

/* ── POPUP D'INSCRIPTION NEWSLETTER (bouton section Newsletter) ── */
(function() {
  const openBtn = document.getElementById('NewsletterOpenBtn');
  const modal = document.getElementById('NewsletterSignupModal');
  if (!openBtn || !modal) return;

  const backdrop = document.getElementById('NewsletterSignupBackdrop');
  const closeBtn = document.getElementById('NewsletterSignupClose');

  let releaseFocusTrap = null;
  let lastFocusedEl = null;

  function open() {
    lastFocusedEl = document.activeElement;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    releaseFocusTrap = doreTrapFocus(modal);
    const focusable = doreFocusableElements(modal);
    if (focusable.length) focusable[0].focus();
  }

  function close() {
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (releaseFocusTrap) { releaseFocusTrap(); releaseFocusTrap = null; }
    if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') { lastFocusedEl.focus(); lastFocusedEl = null; }
  }

  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (backdrop) backdrop.addEventListener('click', close);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) close();
  });

  // Après soumission du formulaire, Shopify recharge la page avec #newsletter-signup-form
  // dans l'URL : on rouvre le popup automatiquement pour montrer le message de résultat.
  if (window.location.hash === '#newsletter-signup-form' || modal.classList.contains('open')) {
    open();
  }
})();

/* ── PRODUITS RÉCEMMENT CONSULTÉS ── */
(function() {
  const container = document.getElementById('RecentlyViewed');
  const grid = document.getElementById('RecentlyViewedGrid');
  if (!container || !grid) return;

  const STORAGE_KEY = 'dore-recently-viewed';
  const limit = parseInt(container.dataset.limit, 10) || 4;
  const currentId = container.dataset.currentId ? parseInt(container.dataset.currentId, 10) : null;

  let list = [];
  try { list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (e) { list = []; }
  list = list.filter(function(p) { return p.id !== currentId; }).slice(0, limit);
  if (!list.length) return;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  grid.innerHTML = list.map(function(p) {
    const title = doreEscapeHTML(p.title);
    const compareHtml = (p.compare_at_price && p.compare_at_price > p.price)
      ? '<span class="price-old">' + formatMoney(p.compare_at_price) + '</span>'
      : '';
    const imgHtml = p.image
      ? '<img src="' + p.image + '" alt="" loading="lazy" width="600" height="780">'
      : '';
    return '<div class="product-card">' +
      '<div class="product-img"><a href="' + p.url + '" aria-label="' + title + '"><div class="product-visual">' + imgHtml + '</div></a></div>' +
      '<div class="product-info">' +
        '<h3 class="product-name"><a href="' + p.url + '">' + title + '</a></h3>' +
        '<div class="product-price"><span class="price-current">' + formatMoney(p.price) + '</span>' + compareHtml + '</div>' +
      '</div>' +
    '</div>';
  }).join('');

  container.style.display = '';
})();

/* ── RECOMMANDATIONS PRODUITS (moteur natif Shopify) ── */
document.querySelectorAll('.related-products-wrapper[data-url]').forEach(function(wrapper) {
  fetch(wrapper.dataset.url)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const recommendations = doc.querySelector('.related-products-wrapper');
      if (recommendations && recommendations.innerHTML.trim()) {
        wrapper.innerHTML = recommendations.innerHTML;
        wrapper.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('visible'); });
      }
    })
    .catch(function() {});
});

/* ── PAGE FAVORIS (wishlist complète) ── */
(function() {
  const STORAGE_KEY = 'dore-wishlist';
  const grid       = document.getElementById('WishlistGrid');
  const emptyState = document.getElementById('WishlistEmpty');
  const countEl    = document.getElementById('WishlistCount');
  if (!grid || !emptyState || !countEl) return;

  let items = [];
  try { items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) {}

  // Compatibilité ancien format (tableau de strings)
  items = items.map(i => typeof i === 'string' ? { id: i, handle: null } : i);
  items = items.filter(i => i.handle); // garde seulement ceux avec un handle

  if (!items.length) {
    emptyState.hidden = false;
    countEl.textContent = '0 article';
    return;
  }

  function buildProductCard(p) {
    const safeTitle = doreEscapeHTML(p.title);
    const safeType = doreEscapeHTML(p.product_type);
    const img   = p.featured_image || '';
    const img2  = p.images?.[1] || '';
    const v     = p.variants?.[0];
    const price = v ? (v.price / 100).toFixed(2).replace('.', ',') + ' €' : '';
    const oldPrice = v?.compare_at_price && v.compare_at_price > v.price
      ? `<span class="price-old">${(v.compare_at_price/100).toFixed(2).replace('.',',')} €</span>` : '';
    const available = p.variants?.some(v => v.available);
    const addBtn = available
      ? `<button class="action-btn action-btn-primary wishlist-page-add" data-id="${v.id}">Ajouter au panier</button>`
      : `<span class="action-btn action-btn-primary action-btn--disabled">Épuisé</span>`;

    return `
      <div class="product-card" data-product-id="${p.id}">
        <div class="product-img">
          <a href="/products/${p.handle}" aria-label="${safeTitle}">
            <div class="product-visual">
              ${img ? `<img src="${img}" alt="${safeTitle}" width="600" height="780" loading="lazy">` : ''}
              ${img2 ? `<img src="${img2}" alt="${safeTitle}" width="600" height="780" loading="lazy" class="product-img-hover">` : ''}
            </div>
            <div class="product-glow"></div>
          </a>
          <div class="product-actions">
            ${addBtn}
            <button class="action-btn action-btn-secondary wishlist-btn active"
              data-product-id="${p.id}"
              aria-label="Retirer des favoris"
              style="color:var(--or-rose)">♥</button>
          </div>
        </div>
        <div class="product-info">
          <div class="product-meta">
            <span class="product-category">${safeType}</span>
          </div>
          <h3 class="product-name"><a href="/products/${p.handle}">${safeTitle}</a></h3>
          <div class="product-price">
            <span class="price-current">${price}</span>
            ${oldPrice}
          </div>
        </div>
      </div>`;
  }

  // Charge chaque produit via son handle — route toujours dispo sur Shopify
  const fetches = items.map(item =>
    fetch(`/products/${item.handle}.js`)
      .then(r => r.ok ? r.json() : null)
      .catch(() => null)
  );

  Promise.all(fetches).then(products => {
    const valid = products.filter(Boolean);
    grid.innerHTML = '';
    emptyState.hidden = true;

    if (!valid.length) {
      emptyState.hidden = false;
      countEl.textContent = '0 article';
      return;
    }

    countEl.textContent = valid.length + (valid.length > 1 ? ' articles' : ' article');
    grid.innerHTML = valid.map(buildProductCard).join('');
    grid.classList.add('loaded');

    // Bouton "Ajouter au panier"
    grid.querySelectorAll('.wishlist-page-add').forEach(btn => {
      btn.addEventListener('click', function() {
        const variantId = this.dataset.id;
        if (!variantId) return;
        const orig = this.textContent;
        this.textContent = 'Ajout…';
        this.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(() => {
          this.textContent = '✓ Ajouté';
          setTimeout(() => { this.textContent = orig; this.disabled = false; }, 2000);
          if (typeof updateCartCount === 'function') updateCartCount();
        })
        .catch(() => { this.textContent = orig; this.disabled = false; });
      });
    });

    // Bouton cœur — retirer des favoris
    grid.querySelectorAll('.wishlist-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const pid = String(this.dataset.productId);
        let wl    = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        wl = wl.filter(i => String(i.id) !== pid && String(i) !== pid);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(wl));

        const card = this.closest('.product-card');
        if (card) {
          card.style.transition = 'opacity .3s, transform .3s';
          card.style.opacity    = '0';
          card.style.transform  = 'scale(.95)';
          setTimeout(() => {
            card.remove();
            const remaining = grid.querySelectorAll('.product-card').length;
            countEl.textContent = remaining + (remaining > 1 ? ' articles' : ' article');
            if (!remaining) { grid.innerHTML = ''; emptyState.hidden = false; }
          }, 300);
        }

        const headerBadge = document.getElementById('WishlistBadge');
        if (headerBadge) {
          headerBadge.textContent  = wl.length;
          headerBadge.style.display = wl.length ? 'flex' : 'none';
        }
      });
    });
  });
})();

/* ── FORMULAIRE DE CONTACT ── */
(function() {
  const textarea = document.getElementById('ContactFormMessage');
  const counter = document.getElementById('CharCount');
  if (textarea && counter) {
    const maxLen = 1000;
    textarea.setAttribute('maxlength', maxLen);
    textarea.addEventListener('input', function() {
      const len = this.value.length;
      counter.textContent = len + ' / ' + maxLen + ' caractères';
      counter.style.opacity = len > maxLen * 0.9 ? '0.8' : '0.4';
      counter.style.color = len >= maxLen ? '#C4877A' : '';
    });
  }

  // Feedback bouton à la soumission
  const form = document.getElementById('ContactForm');
  if (form) {
    form.addEventListener('submit', function() {
      const btn = document.getElementById('ContactSubmit');
      const txt = btn?.querySelector('.contact-form__submit-text');
      const loading = btn?.querySelector('.contact-form__submit-loading');
      if (btn && txt && loading) {
        btn.disabled = true;
        txt.style.display = 'none';
        loading.style.display = 'inline';
      }
    });
  }

  // Animation entrée des blocs info
  const blocks = document.querySelectorAll('.contact-info__block');
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.style.opacity = '1', i * 100);
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    blocks.forEach(b => { b.style.opacity = '0'; b.style.transition = 'opacity 0.6s ease'; obs.observe(b); });
  }
})();

/* ── NAV DROPDOWNS (Catalogue, La Maison...) ── */
(function () {
  const groups = document.querySelectorAll('.nav-dropdown-group');
  if (!groups.length) return;

  groups.forEach(function (wrap) {
    const trigger = wrap.querySelector('[aria-controls]');
    const panel = trigger && document.getElementById(trigger.getAttribute('aria-controls'));
    if (!trigger || !panel) return;
    let closeTimer;

    function open() {
      clearTimeout(closeTimer);
      wrap.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
    }
    function close() {
      wrap.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
    }
    function scheduleClose() {
      closeTimer = setTimeout(close, 180);
    }

    wrap.addEventListener('mouseenter', open);
    wrap.addEventListener('mouseleave', scheduleClose);

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      wrap.classList.contains('open') ? close() : open();
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });
})();

/* ── FOOTER ACCORDION (mobile) ── */
(function () {
  document.querySelectorAll('.footer-col-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const body = document.getElementById(this.getAttribute('aria-controls'));
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      if (body) body.classList.toggle('open', !expanded);
    });
  });
})();